import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CardInstruction from '../../../../components/CardInstruction';

import { getStatementServiceId } from '../../../form/StatementLetterForm/functions';

const Birth = ({ i18n, statementServiceList }) => {
  const lang = (type, params) => i18n(`statement_letter.tab5.${type}`, { ...params });
  const serviceId = getStatementServiceId(statementServiceList, 'domisili');

  const stepOuterList = [
    {
      label: i18n('statement_letter.step.report_self.title')
    },
    // {
    //   label: i18n('statement_letter.step.take_number.title'),
    //   cta: i18n('statement_letter.step.take_number.cta'),
    //   link: `/statement-letter/registration/create?type=statement&serviceId=${serviceId}`
    // }
  ];

  const instructionList = [
    i18n('statement_letter.instruction_step.copy_passport_apply'),
    i18n('statement_letter.instruction_step.address_us'),
    i18n('statement_letter.instruction_step.live_permit'),
    i18n('statement_letter.instruction_step.no_fee')
  ];

  return (
    <CardInstruction
      stepOuterList={stepOuterList}
      instructionList={instructionList}
      lang={lang}
    />
  );
};

Birth.propTypes = {
  i18n: PropTypes.func,
  statementServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(Birth);
